var map = {
	"./about-us-banner.webp": 219,
	"./anniversary-banner-bm.webp": 1585,
	"./anniversary-banner-cn.webp": 1586,
	"./anniversary-banner-id.webp": 1587,
	"./anniversary-banner.webp": 1588,
	"./banner-01.jpg": 1589,
	"./banner-slot.jpg": 1590,
	"./bet-and-earn-banner-cn.webp": 1591,
	"./bet-and-earn-banner-indon.webp": 1592,
	"./bet-and-earn-banner-ms.webp": 1593,
	"./bet-and-earn-banner.webp": 1594,
	"./check-in-banner-cn.webp": 1595,
	"./check-in-banner-id.webp": 1596,
	"./check-in-banner-ms.webp": 1597,
	"./check-in-banner.webp": 1598,
	"./cny_2024-bm.webp": 1599,
	"./cny_2024-cn.webp": 1600,
	"./cny_2024.webp": 1601,
	"./epl-banner-cn.jpg": 1602,
	"./epl-banner-cn.webp": 1603,
	"./epl-banner-indo.jpg": 1604,
	"./epl-banner-indo.webp": 1605,
	"./epl-banner-ms.jpg": 1606,
	"./epl-banner-ms.webp": 1607,
	"./epl-banner.jpg": 1608,
	"./epl-banner.webp": 1609,
	"./games-banner-cn.webp": 1610,
	"./games-banner-id.webp": 1611,
	"./games-banner-ms.webp": 1612,
	"./games-banner.webp": 1613,
	"./lb-m-banner-cn.webp": 1614,
	"./lb-m-banner.webp": 1615,
	"./leaderboard-banner-cn.webp": 1616,
	"./leaderboard-banner.webp": 1617,
	"./lottery-banner.webp": 1618,
	"./lottery-banners-cn.webp": 1619,
	"./lottery-banners-id.webp": 1620,
	"./lottery-banners-ms.webp": 1621,
	"./lottery-banners.webp": 1622,
	"./lucky-spin-banner-cn.webp": 1623,
	"./lucky-spin-banner-ms.webp": 1624,
	"./lucky-spin-banner-vn.webp": 1625,
	"./lucky-spin-banner.webp": 1626,
	"./p2p-banner.webp": 1627,
	"./p2p-banners-cn.webp": 1628,
	"./p2p-banners-id.webp": 1629,
	"./p2p-banners-ms.webp": 1630,
	"./p2p-banners.webp": 1631,
	"./premier-league-banner-cn.webp": 1632,
	"./premier-league-banner.webp": 1633,
	"./promos-banner-cn.webp": 1634,
	"./promos-banner-indon.webp": 1635,
	"./promos-banner-ms.webp": 1636,
	"./promos-banner.webp": 1637,
	"./promos-detail-banner.jpg": 1638,
	"./side-bar-banner.jpg": 1639,
	"./slot-banners-cn.webp": 1640,
	"./slot-banners-ms.webp": 1641,
	"./slot-banners.webp": 1642,
	"./speed-banners-cn.webp": 1643,
	"./speed-banners-ms.webp": 1644,
	"./speed-banners.webp": 1645,
	"./uefa24-prediction-bm.webp": 1646,
	"./uefa24-prediction-cn.webp": 1647,
	"./uefa24-prediction-id.webp": 1648,
	"./uefa24-prediction.webp": 1649,
	"./vip-banner-cn.webp": 1650,
	"./vip-banner-id.webp": 1651,
	"./vip-banner-ms.webp": 1652,
	"./vip-banner-vn.webp": 1653,
	"./vip-banner.webp": 1654,
	"./winner-leaderboard-banner-cn.webp": 1655,
	"./winner-leaderboard-banner.webp": 1656,
	"./world-cup-banner-cn.webp": 1657,
	"./world-cup-banner.webp": 1658,
	"./world-cup-two-banner-cn.webp": 1659,
	"./world-cup-two-banner.webp": 1660,
	"./xmas_2023-bm.jpg": 1661,
	"./xmas_2023-cn.jpg": 1662,
	"./xmas_2023-id.jpg": 1663,
	"./xmas_2023.jpg": 1664,
	"./xmas_2024-bm.webp": 1665,
	"./xmas_2024-cn.webp": 1666,
	"./xmas_2024.webp": 1667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;